import { ScanConfigV1OutputDto } from 'generated/apiSchemas';

/**
 * Extracts the serial number from a scanned code.
 * When extracting from the end, startIndex is the number of characters ignored at the end.
 * The start is clamped to 0 so a too short code is truncated, as when extracting from the start.
 */
export const extractSerialNumber = (
  scannedCode: string,
  { startIndex, extractLength, extractFromEnd }: ScanConfigV1OutputDto,
) => {
  if (!extractFromEnd) {
    return scannedCode.slice(startIndex, startIndex + extractLength);
  }

  const end = scannedCode.length - startIndex;
  return scannedCode.slice(Math.max(0, end - extractLength), end);
};
